<template>
  <router-view />
</template>

<script>
export default {
  name: "app-order"
};
</script>

<style lang="scss" scoped></style>
